import React, { Fragment, useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../api"
import {
  Col,
  Input,
  Row,
  Button,
  CardTitle,
  Modal,
  ModalBody,
  ModalHeader, Label,
} from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import Select from "react-select"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { Link } from "react-router-dom"
const RegroupementMatiere = props => {
  const [orders, setOrders] = useState([])
  const [arrayMatiere, setArrayMatiere] = useState([
    {
      cycle_id: "",
      niveau_id: "",
      semestre_id: "",
      specialite_id: "",
      matiere_id: "",
      type_matiere:""
    },
  ])
  const [modal, setModal] = useState(false)
  const [modalDeleteReg, setModalDeleteReg] = useState(false)
  const [indexLigne, setIndexLigne] = useState("")
  const [semestre, setSemestre] = useState([
    { value: 1, label: "Semestre 1" },
    { value: 2, label: "Semestre 2" },
  ])
  const [cycle, setCycle] = useState([])
  const [niveau, setNiveau] = useState([])
  const [specialite, setSpecialite] = useState([])
  const [matiere, setMatiere] = useState([])
  const [typeMatiere, setTypeMatiere] = useState([])
  const [disbutReg, setDisbutReg] = useState(true)
  const [id, setId] = useState("")
  const [edit, setEdit] = useState(0)
  const [delet, setDelet] = useState(0)
  const [cloture, setCloture] = useState(0)
  const [add, setAdd] = useState(0)
  const [title, setTitle] = useState("")
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id

  useEffect(async () => {
    setTitle("Ajouter regroupement matière")
    setArrayMatiere([
      {
        cycle_id: "",
        niveau_id: "",
        semestre_id: "",
        specialite_id: "",
        matiere_id: "",
        type_matiere: "",
      },
    ]);
    var cloture_annee = JSON.parse(localStorage.getItem("cloture"))
    setCloture(cloture_annee)
    const userAuth = JSON.parse(localStorage.getItem("UserMenu"))
    const typeArticleSubMenu = userAuth.find(user =>
      user.sous_menu.some(subMenu => subMenu.sous_menu === "Matière")
    )
    setAdd(typeArticleSubMenu.sous_menu[2].add)
    setEdit(typeArticleSubMenu.sous_menu[2].edit)
    setDelet(typeArticleSubMenu.sous_menu[2].delete)
    const res = await API.get("cycle/select").then(res => {
      setCycle(res.data.Cycle)
    })
    fetchData()
  }, [])
  const fetchData = async () => {
    const resList = await API.post("regroupement_matieres/list",{annee_id})
    // aplatissement
    const regroupements = resList.data.RegroupementMatieres.flatMap(g =>
      g.ligne.map((l, index) => ({
        id: `${g.groupe_code}-${l.matiere_id.value}`, // clé unique
        groupe_code: g.groupe_code,
        annee_id: g.annee_id,
        cycle: l.cycle_id.label,
        niveau: l.niveau_id.label,
        semestre: l.semestre_id.label,
        matiere_name: l.matiere_id.label,
        matiere_type: l.type_matiere.label,
        specialite: l.specialite_id.label,
      }))
    )
    setOrders(regroupements)
  }
  const addCycle = (event, index) => {
    const cycle_id = event.value
    setArrayMatiere(prev =>
      prev.map((el, id) =>
        id === index
          ? { ...el, cycle_id: event, niveau_id: "", semestre_id: "", specialite_id: "", matiere_id: "" ,type_matiere: ""}
          : el
      )
    )
    if (cycle_id === 1) {
      API.get("niveau/select").then(res => {
        setNiveau(res.data.Niveau)
      })
    } else {
      API.get("niveau/select_mastere").then(res => {
        setNiveau(res.data.Niveau)
      })
    }
  }
  const addNiveau = (event, index) => {
    setArrayMatiere(prev =>
      prev.map((el, id) =>
        id === index
          ? { ...el,niveau_id: event, semestre_id: "",  specialite_id: "", matiere_id: "",type_matiere: ""}
          : el
      )
    )
  }
  const addSemestre = (event, index) => {
    setArrayMatiere(prev =>
      prev.map((el, id) =>
        id === index
          ? { ...el, semestre_id: event, specialite_id: "", matiere_id: "",type_matiere: "" }
          : el
      )
    )
    const selectedItem = arrayMatiere[index]
    const niveau_id = selectedItem.niveau_id?.value || selectedItem.niveau_id
    const cycle_id = selectedItem.cycle_id?.value || selectedItem.cycle_id
    const semestre_id = event.value
    API.post("specialite/get_by_niveaux_cycle_semestre", {
      semestre_id,
      niveau_id,
      cycle_id,
    }).then(res => {
      setSpecialite(res.data.Specialites)
    })
  }

  const addSpecialite = (event, index) => {
    setArrayMatiere(prev =>
      prev.map((el, id) =>
        id === index
          ? { ...el, specialite_id: event, matiere_id: "",type_matiere: "" }
          : el
      )
    )
    const selectedItem = arrayMatiere[index]
    const specialite_id = event.value
    const semestre_id = selectedItem.semestre_id?.value || selectedItem.semestre_id
    const niveau_id = selectedItem.niveau_id?.value || selectedItem.niveau_id
    const cycle_id = selectedItem.cycle_id?.value || selectedItem.cycle_id
    API.post("matiere/get_by_cycle_niveaux_semestre_specialite", {
      specialite_id,
      semestre_id,
      niveau_id,
      cycle_id,
    }).then(res => {
      setMatiere(res.data.Matiere)
    })
  }

  const addMatiere = (event, index) => {
    setArrayMatiere(prev =>
      prev.map((el, id) =>
        id === index
          ? { ...el, matiere_id: event,type_matiere: ""}
          : el
      )
    )
    API.post("matiere/get_detail", {
      matiere_id:event.value,
    }).then(res => {
      setTypeMatiere(res.data.Matiere)
    })
  }
  const addTypeMatiere = (event, index) => {
    setArrayMatiere(prev =>
      prev.map((el, id) =>
        id === index
          ? { ...el, type_matiere: event}
          : el
      )
    )

  }
  const addLigne = () => {
    let element = {
      cycle_id: "",
      niveau_id: "",
      semestre_id: "",
      specialite_id: "",
      matiere_id: ""
    }
    setArrayMatiere([...arrayMatiere, element])
  }
  const toggle = indexOfLigne => {
    setModal(!modal)
    setIndexLigne(indexOfLigne)
  }
  const toggleDeleteReg = id => {
    setModalDeleteReg(!modalDeleteReg)
    setId(id)
  }
  const toggleDelete = async () => {
    arrayMatiere.splice(indexLigne, 1)
    setModal(false)
  }
  const toggleDeleteRegMatiere = async () => {
    const res = await API.post("regroupement_matieres/delete", {
      groupe_code: id,
      user_id,
      annee_id,
    }).then(res => {
      setModalDeleteReg(false)
      fetchData()
    })
  }
  const save = async () => {
    if (arrayMatiere.length < 2) {
      setDisbutReg(true); // assure que le bouton reste activé
      toast.error("⛔ Le regroupement doit contenir au minimum 2 matières", {
        containerId: "A",
      });
      return;
    }
    const payloadLignes = arrayMatiere.map(item => ({
      cycle_id: item.cycle_id === "" ? 0 : item.cycle_id,
      niveau_id: item.niveau_id === "" ? 0 : item.niveau_id,
      semestre_id: item.semestre_id === "" ? 0 : item.semestre_id,
      specialite_id: item.specialite_id === "" ? 0 : item.specialite_id,
      matiere_id: item.matiere_id === "" ? 0 : item.matiere_id,
      type_matiere: item.type_matiere ?? "",
    }));
    setDisbutReg(false);
    try {
      const res = await API.post("regroupement_matieres/add", {
        ligne: payloadLignes,
        annee_id,
        user_id,
      });
      if(res.data.errNum === 422 || res.data.errNum === "422"){
        setDisbutReg(true);
        toast.error("⛔"+res.data.msg, { containerId: "A"})
      }else{
        setArrayMatiere([
          {
            cycle_id: "",
            niveau_id: "",
            semestre_id: "",
            specialite_id: "",
            matiere_id: "",
            type_matiere: "",
          },
        ]);
        fetchData();
        toast.success("✅ Regroupement enregistré avec succès !");
      }
    } catch (error) {
      console.error(error);
      toast.error("❌ Erreur lors de l’enregistrement du regroupement !");
    } finally {
      setDisbutReg(true);
    }
  };
  const annuler = async () => {
    setTitle("Ajouter regroupement matière")
     setArrayMatiere([
       {
         cycle_id: "",
         niveau_id: "",
         semestre_id: "",
         specialite_id: "",
         matiere_id: "",
         type_matiere: "",
       },
     ]);
     await fetchData()
  };
  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = data => [
    {
      dataField: "groupe_code",
      text: "Code groupe",
      // eslint-disable-next-line react/display-name
      formatter: (cell, row, rowIndex) => {
        const prev = data[rowIndex - 1];
        const currentGroup = row.groupe_code;

        if (!prev || prev.groupe_code !== currentGroup) {
          let rowSpan = 1;
          for (let i = rowIndex + 1; i < data.length; i++) {
            if (data[i].groupe_code === currentGroup) rowSpan++;
            else break;
          }

          // Stocker le rowSpan dans data-attribut
          return (
            <span data-rowspan={rowSpan}>
            {currentGroup}
          </span>
          );
        }
        return (
          <span data-rowspan={0}>
            {currentGroup}
          </span>
        );
      },
      style: { textAlign: "center", verticalAlign: "middle" },
      headerStyle: { textAlign: "center" },
    },
    // {
    //   dataField: "groupe_code",
    //   text: "Code groupe",
    //   formatter: (cell, row, rowIndex) => {
    //     const prev = data[rowIndex - 1]
    //     if (!prev || prev.groupe_code !== row.groupe_code)
    //       return row.groupe_code
    //     return ""
    //   },
    //   style: { textAlign: "center" },
    //   headerStyle: { textAlign: "center" },
    // },
    {
      dataField: "cycle",
      text: "Cycle",
      style: { textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "niveau",
      text: "Niveau",
      style: { textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "semestre",
      text: "Semestre",
      style: { textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "matiere_name",
      text: "Matière",
      formatter: (cell, row, rowIndex) => {
        const prev = data[rowIndex - 1]
        if (!prev || prev.matiere_name !== row.matiere_name)
          return row.matiere_name
        return ""
      },
      style: { textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "matiere_type",
      text: "Type Matière",
      formatter: (cell, row, rowIndex) => {
        const prev = data[rowIndex - 1]
        if (!prev || prev.matiere_type !== row.matiere_type)
          return row.matiere_type
        return ""
      },
      style: { textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "specialite",
      text: "Spécialité",
      style: { textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "Action",
      isDummyField: true,
      text: "Action",
      style: { textAlign: "center" },
      headerStyle: () => ({ textAlign: "center" }),
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <div style={{ display: "flex", justifyContent: "space-evenly" }}>
          {/* === EDIT === */}
          {cloture !== 1 ? (
            edit === 1 ? (
              <i
                style={{
                  color: "cornflowerblue",
                  cursor: "pointer",
                  fontSize: "15px",
                }}
                className="fas fa-edit"
                title="Modifier cette matière"
                onClick={() => editLigne(row.groupe_code)}
              ></i>
            ) : (
              <i
                style={{
                  color: "#a7a3a3",
                  cursor: "pointer",
                  fontSize: "15px",
                }}
                className="fas fa-edit"
                title="Vous n'avez pas d'accès"
              ></i>
            )
          ) : (
            <i
              style={{ color: "#a7a3a3", cursor: "pointer", fontSize: "15px" }}
              className="fas fa-edit"
              title="Année clôturée"
            ></i>
          )}

          {/* === DELETE === */}
          {cloture !== 1 ? (
            delet === 1 ? (
              row.etat !== 0 ? (
                <i
                  style={{
                    color: "#ED6464",
                    cursor: "pointer",
                    fontSize: "15px",
                  }}
                  onClick={() => toggleDeleteReg(row.groupe_code)}
                  className="fas fa-trash-alt"
                  title={"Supprimer cette matière ?"}
                ></i>
              ) : (
                <i
                  style={{
                    color: "#A7A3A3",
                    cursor: "pointer",
                    fontSize: "15px",
                  }}
                  className="fas fa-trash-alt"
                  title="Cette matière est déjà utilisée"
                ></i>
              )
            ) : (
              <i
                style={{
                  color: "#A7A3A3",
                  cursor: "pointer",
                  fontSize: "15px",
                }}
                className="fas fa-trash-alt"
                title="Vous n'avez pas d'accès"
              ></i>
            )
          ) : (
            <i
              style={{ color: "#A7A3A3", cursor: "pointer", fontSize: "15px" }}
              className="fas fa-trash-alt"
              title="Année clôturée"
            ></i>
          )}
        </div>
      ),
    },
  ]
  const editLigne = (groupe_code) => {
    const res = API.post("regroupement_matieres/get_by_id",{groupe_code})
      .then(res => {
        setTitle("Modifier le regroupement de matière associé au code de regroupement : "+res.data.RegroupementMatiere.groupe_code)
        setArrayMatiere(res.data.RegroupementMatiere.ligne)
    })
  };
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Suivant",
    prePageText: "Précédent",
    alwaysShowAllBtns: true,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 10,
      },
      {
        text: "150",
        value: 150,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }
  const { SearchBar } = Search
  return (
    <React.Fragment>
      <CardTitle style={{ color: "#e1a0a4" }} className="h4 mt-2">
        {title}
      </CardTitle>
      <Row>
        <table className="table table-bordered mt-4">
          <thead>
            <tr>
              <th style={{ textAlign: "center" }} scope="col">
                Cycle
              </th>
              <th style={{ textAlign: "center" }} scope="col">
                Niveau
              </th>
              <th style={{ textAlign: "center" }} scope="col">
                Semestre
              </th>
              <th style={{ textAlign: "center" }} scope="col">
                Spécialite
              </th>
              <th style={{ textAlign: "center" }} scope="col">
                Matière
              </th>
              <th style={{ textAlign: "center" }} scope="col">
                Type Matière
              </th>
              <th style={{ textAlign: "center" }} scope="col">
                <i
                  style={{
                    color: "#a0ceb8",
                    cursor: "pointer",
                  }}
                  className="fas fa-plus"
                  onClick={addLigne}
                />
              </th>
            </tr>
          </thead>
          {arrayMatiere.map((el, index) => (
            <tbody key={index}>
              <tr>
                <td className="col-md-2">
                  <Select
                    options={cycle}
                    isSearchable={true}
                    value={el.cycle_id}
                    onChange={e => addCycle(e, index)}
                  />
                </td>
                <td className="col-md-2">
                  <Select
                    options={niveau}
                    value={el.niveau_id}
                    isSearchable={true}
                    onChange={e => addNiveau(e, index)}
                  />
                </td>
                <td className="col-md-2">
                  <Select
                    options={semestre}
                    value={el.semestre_id}
                    isSearchable={true}
                    onChange={e => addSemestre(e, index)}
                  />
                </td>
                <td className="col-md-2">
                  <Select
                    options={specialite}
                    value={el.specialite_id}
                    isSearchable={true}
                    onChange={e => addSpecialite(e, index)}
                  />
                </td>
                <td className="col-md-2">
                  <Select
                    options={matiere}
                    value={el.matiere_id}
                    isSearchable={true}
                    onChange={e => addMatiere(e, index)}
                  />
                </td>
                <td className="col-md-2">
                  <Select
                    options={typeMatiere}
                    value={el.type_matiere}
                    isSearchable={true}
                    onChange={e => addTypeMatiere(e, index)}
                  />
                </td>
                <td className="col-md-2" style={{ textAlign: "center" }}>
                  <i
                    style={{ color: "#cc0000" }}
                    className="mdi mdi-delete font-size-18"
                    id="deletetooltip"
                    onClick={() => toggle(index)}
                  />
                </td>
              </tr>
            </tbody>
          ))}
        </table>
        <div style={{ display: "flex", justifyContent: "center" }}>
          {" "}
          <Col lg="6">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
              className="text-center mt-4"
            >
              <Button
                type="button"
                color="warning"
                className="btn btn-warning  mb-2 me-2"
                onClick={annuler}
              >
                Annuler
              </Button>
            </div>
          </Col>
          <Col lg="6">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
              }}
              className="text-center mt-4"
            >
              <button type="button" className="btn btn-primary " disabled={!disbutReg} onClick={save}>
                CONFIRMER
              </button>
            </div>
          </Col>
        </div>
      </Row>
      <Row>
        <ToolkitProvider
          keyField="id"
          data={orders}            // ← state contenant les données aplaties
          columns={Columns(orders)} // ← passer le state ici
          search
          bootstrap4
        >
          {toolkitProps => (
            <div style={{ marginTop: "15px" }}>
              <CardTitle style={{ color: "rgba(94,6,82,0.44)" }} className="h4">
                Liste des regroupements matières
              </CardTitle>

              <Col sm="4">
                <div className="search-box me-2 mb-2 d-inline-block">
                  <div className="position-relative">
                    <SearchBar {...toolkitProps.searchProps} />
                    <i className="bx bx-search-alt search-icon" />
                  </div>
                </div>
              </Col>

              <BootstrapTable
                wrapperClasses="table-responsive"
                noDataIndication={() => <NoDataIndication />}
                striped={false}
                bordered={false}
                classes={"table align-middle table-nowrap"}
                headerWrapperClasses={"table-light"}
                hover
                pagination={paginationFactory(pageOptions)}
                {...toolkitProps.baseProps}
              />
            </div>
          )}
        </ToolkitProvider>
      </Row>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <ModalHeader toggle={toggle} tag="h4">
          {" Suppression d'une ligne"}{" "}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>Voulez-vous supprimer cette ligne ?</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  onClick={toggleDelete}
                  color="info"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  Oui
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggle}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  Non
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalDeleteReg} toggle={toggleDeleteReg} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleDeleteReg}
          tag="h4"
        >
          {" Suppression d'une regroupement matière"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>Voulez-vous supprimer cette regrouppement ?</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleDeleteRegMatiere}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  Oui
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleDeleteReg}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  Non
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

    </React.Fragment>
  )
}

export default RegroupementMatiere
RegroupementMatiere.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
}
